import { useTranslation } from 'react-i18next'
import React from 'react'

import Details from '../details/Details'
import PublicTokenCallsList from '../calls/PublicTokenCallsList'

export const useTabsOptions = () => {
  const { t } = useTranslation(['publicToken', 'common'])

  return [
    { name: t('common:details'), render: () => <Details /> },
    { name: t('publicToken:calls'), render: () => <PublicTokenCallsList /> }
  ]
}
